import { useState } from 'react';

import { TariffClassificationApiModel, TariffSectionApiModel } from '~/lib/api/smartsend/types';
import { TariffSection } from './TariffSection';
import { P2GBox, P2GLink, P2GFade } from '@parcel2go/core-ui';

interface props {
  sections: TariffSectionApiModel[];
  getClassifications: (code: string) => Promise<TariffClassificationApiModel[]>;
  selectCode: (code: string) => void;
  canSelect: boolean;
}

const TariffSections: React.FC<props> = (props) => {
  const [selectedSection, setSelectedSection] = useState<string | null>(null);

  return (
    <P2GBox>
      {selectedSection != null && (
        <P2GBox mb={1} bordered p={1} filled>
          <P2GLink onClick={() => setSelectedSection(null)}>Show All</P2GLink>
        </P2GBox>
      )}
      <P2GBox>
        {props.sections
          .filter((x) => selectedSection == x.Id || !selectedSection)
          .map((s) => (
            <P2GBox key={s.Id}>
              <P2GFade in>
                <TariffSection
                  canSelect={props.canSelect}
                  section={s}
                  getClassifications={props.getClassifications}
                  selectCode={props.selectCode}
                  selectSection={setSelectedSection}
                />
              </P2GFade>
            </P2GBox>
          ))}
      </P2GBox>
    </P2GBox>
  );
};

export { TariffSections };
